import { signal } from '@angular/core';

/**
 * Tracks whether `bootstrapDatadogRum` succeeded.
 * Lives outside Angular DI because RUM is initialized in `main.ts` before AppModule bootstraps.
 */
export const datadogRumInitializedSignal = signal(false);
